import React from "react";
import ReactEcharts from "echarts-for-react";
import getChartColorsArray from "../../../components/Common/ChartsDynamicColor";
import moment from "moment";
import "moment/locale/tr"; // Türkçe ay isimleri için

const LineChartMembershipByMonth = ({ dataColors, users }) => {
  moment.locale("tr");
  const lineEChartColors = getChartColorsArray(dataColors);

  // 1. Aylık üyelik sayısını hesapla
  const monthlyCounts = {};
  users.forEach(user => {
    const month = moment(user.Customer_CreatedDate).format("MMM YYYY"); // Örn: "Oca 2025"
    monthlyCounts[month] = (monthlyCounts[month] || 0) + 1;
  });

  // 2. Tarihlere göre sırala
  const sortedMonths = Object.keys(monthlyCounts).sort((a, b) =>
    moment(a, "MMM YYYY").toDate() - moment(b, "MMM YYYY").toDate()
  );

  // 3. X ve Y verisi
  const xAxisData = sortedMonths;
  const seriesData = sortedMonths.map(month => monthlyCounts[month]);

  // 4. Grafik ayarları
  const options = {
    tooltip: { trigger: "axis" },
    grid: { zlevel: 0, x: 50, x2: 50, y: 30, y2: 30, borderWidth: 0 },
    xAxis: {
      type: "category",
      data: xAxisData,
      axisLabel: {
     
        fontSize: 12,
      },
      axisLine: {
        lineStyle: { color: "#8791af" },
      },
    },
yAxis: {
  type: "value",
  minInterval: 1, // her aralık en az 1 olsun
  interval: 1,    // aralıklar tam sayı olsun
  axisLabel: {
    formatter: '{value}', // 1, 2, 3 şeklinde yazdır
  },
  axisLine: {
    lineStyle: {
      color: "#8791af"
    },
  },
  splitLine: {
    lineStyle: {
      color: "rgba(166, 176, 207, 0.1)"
    }
  }
},
    series: [
      {
        data: seriesData,
        type: "line",
        smooth: true,
      },
    ],
    color: lineEChartColors,
    textStyle: { color: ["#8791af"] },
  };

  return (
    <div id="line-chart" className="e-chart">
      <ReactEcharts style={{ height: "350px" }} option={options} />
    </div>
  );
};

export default LineChartMembershipByMonth;
